import { render } from "./CustomRangeSimple.vue?vue&type=template&id=7f2e4785"
import script from "./CustomRangeSimple.vue?vue&type=script&lang=js"
export * from "./CustomRangeSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__